<script>
  import Icon from '@iconify/svelte'

  import LinkButton from '~/components/ui/link-button.svelte'
  import LinkLocale from '~/components/ui/link-locale.svelte'

  let { headerIsActive } = $props()
  // prettier-ignore
  /**
   * @type {import("./header.types").SocialItem[]}
   */
  let socials = [
		{ ariaLabel: "Instagram - Criação de sites e softwares personalizados | Lutruvials", anchorTo: "https://www.instagram.com/lutruvials.oficial/", icon: 'ri:instagram-line' },
		{ ariaLabel: "Behance - Design profissional | Lutruvials"  , anchorTo: "https://www.behance.net/lutruvials" , icon: 'ri:behance-fill' },
	];

  let showMenu = $state(false)
  let headerActive = $derived(headerIsActive)

  const handleOnScroll = () => {
    if (!headerIsActive) {
      if (typeof window !== 'undefined') {
        if (window.scrollY > 70) {
          headerActive = true
        } else {
          headerActive = false
        }
      }
    }
  }
</script>

<svelte:window onscroll={handleOnScroll} />

<header class:bg-white={headerActive || showMenu} class="fixed left-0 top-0 z-[400] w-full">
  <div class="mx-auto px-4 lg:w-[80%] lg:px-0">
    <nav
      class:border-gray-200={headerActive || showMenu}
      class:border-b={headerActive || showMenu}
      class="flex w-full items-center justify-between py-3"
    >
      <div class="flex items-center gap-8">
        <LinkLocale href="/">
          <figure class="relative">
            <img
              class="size-auto w-[128px]"
              src="/png/logo-extend.png"
              alt="Nossa logo representa o processo de construção para sistemas escalavéis"
            />
            <figcaption class="sr-only">
              Lutruvials | Nossa marca foca em transformação digital
            </figcaption>
          </figure>
        </LinkLocale>

        <div
          class={`fixed -right-[100%] top-[67px] w-[100%] border-b border-gray-200 bg-white p-4 transition-all lg:static lg:top-auto lg:w-auto lg:border-none lg:bg-transparent lg:p-0 ${showMenu ? '!right-0' : ''}`}
          data-sveltekit-reload
        >
          <ul class="mb-4 flex flex-col gap-3 lg:mb-0 lg:flex lg:flex-row">
            <li>
              {@render link('Quem somos', '/sobre', headerActive, showMenu)}
            </li>

            <li>
              {@render link('Serviços', '/servicos', headerActive, showMenu)}
            </li>

            <li>
              {@render link('Contato', '/contato', headerActive, showMenu)}
            </li>

            <!-- <li>
              <SolutionsAction />
            </li> -->
          </ul>

          <div class="row | justify-end gap-3 rounded-b-md bg-gray-50 lg:hidden">
            {#each socials as socialItem}<a
                class="center | size-[32px] flex-shrink-0 rounded-md bg-gray-100 hover:bg-gray-100 hover:shadow-md"
                href={socialItem.anchorTo || '/'}
              >
                <Icon
                  class="size-[24px] text-[24px] leading-[24px] text-brand"
                  icon={socialItem.icon}
                ></Icon>
                <span class="sr-only">{socialItem.ariaLabel}}</span>
              </a>
            {/each}
          </div>
        </div>
      </div>

      <div class="flex items-center gap-4 lg:gap-8">
        <!-- <div class="flex items-center gap-2 rounded-full px-1 py-1">
					<div class="relative flex items-stretch gap-2" data-sveltekit-reload>
						{#if show}
							{#each locales as localeItem}
								<a
									href={localeItem.anchorTo}
									class:!text-black={headerActive}
									class="px-2 py-1 font-medium text-white"
								>
									<span>{localeItem.locale}</span>
								</a>
							{/each}
						{/if}

						{#if !show}
							{#if localeItem}
								<a
									href={localeItem.anchorTo}
									class:!text-black={headerActive}
									class="px-2 py-1 font-bold text-white"
								>
									<span>{localeItem.locale}</span>
								</a>
							{/if}
						{/if}

						<button
							onclick={() => (show = !show)}
							class:absolute={!show}
							class:sr-only={show}
							class="left-0 top-0 h-full w-full"
						>
							<span class="sr-only">Abrir menu idiomas</span>
						</button>
					</div>

					<button
						onclick={() => (show = !show)}
						class:!text-black={headerActive}
						class="cursor-pointer text-white"
					>
						<Icon class={`transition ${!show ? 'rotate-90' : 'rotate-0'}`} icon="ri:play-fill" />
					</button>
				</div> -->

        <!-- 
				<div class="hidden lg:block">
					<div class="row | -mr-4 w-auto justify-end gap-3 rounded-b-md bg-transparent px-2 py-2">
						{#each socials as socialItem}
							{@render social(socialItem.anchorTo, socialItem.ariaLabel, socialItem.icon)}
						{/each}
					</div>
				</div>
				 -->

        <button
          class="text-white lg:hidden"
          class:!text-black={headerActive || showMenu}
          onclick={() => (showMenu = !showMenu)}
        >
          <Icon class="text-[32px]" icon="gg:menu"></Icon>
        </button>

        <a
          class="flex items-center gap-1.5 rounded-lg bg-brand-500 px-4 py-3 text-white transition-all hover:scale-105 hover:bg-secondary hover:text-black"
          href="https://wa.me/5511993108947?text=Ol%C3%A1%20gostaria%20de%20ver%20um%20or%C3%A7amento%20sem%20compromisso."
          target="_blank"
        >
          <Icon icon="fa6-brands:whatsapp" class="text-2xl" />
          <span>Solicitar proposta</span>
        </a>
      </div>
    </nav>
  </div>
</header>

{#snippet link(
  /** @type {string}  */ name,
  /** @type {string}  */ href,
  /** @type {boolean} */ headerActive,
  /** @type {boolean} */ showMenu
)}
  <LinkButton
    class={`flex w-full items-center justify-start rounded-md bg-gray-50 px-4 py-3 hover:bg-gray-200 lg:block lg:w-auto lg:bg-transparent lg:p-0 lg:hover:bg-transparent ${!headerActive && !showMenu ? 'text-black' : ''}`}
    colorPalette="black"
    variant="plain"
    size="none"
    {href}
  >
    {name}
  </LinkButton>
{/snippet}
